module.exports = "/_next/static/images/BadgeEnterprise@2x-743c763aeea09d0906fe7c44b2781167.webp";